<form [formGroup]="form" class="container">
  <app-titulo>{{ !isEditing ? 'Cadastro' : 'Edição' }} de Perfil</app-titulo>
  <span></span>
  <app-input
    type="email"
    label="Digite o nome do perfil:"
    name="NM_PERF"
    formControlName="NM_PERF"
    placeholder="Digite aqui"></app-input>
  <div class="buttons">
    <app-botao text="Cancelar" bgColor="#B91C1C" (click)="onCancelar()" />
    <app-botao
      text="Confirmar"
      [bgColor]="!form.valid ? '' : '#059669'"
      (click)="onConfirmar()"
      [disabled]="!form.valid" />
  </div>
</form>

<app-loader *ngIf="isLoading" />
